import React, { Component } from 'react';
import { Row, Col } from 'antd';
import SubScreenHeader from '../components/SubScreenHeader';
import Footer from '../components/Footer';
import LeftMenu from '../components/LeftMenu';
import DigitalTransformationContent from '../components/DigitalTransformation/DigitalTransformationContent';
import StoreManager from '../appdata';
import languages from '../appdata/languages';

class DigitalTransformationScreen extends Component {
  componentDidMount() {
    // Set default state for subPageContent nếu chưa có
    if (!StoreManager.appState.thisApp.state.subPageContent) {
      StoreManager.appState.thisApp.setState({
        subPageContent: 'DigitalTransformationContent',
      });
    }
  }

  render() {
    const { subPageContent } = StoreManager.appState.thisApp.state;
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;

    const sections = [
      content.submenuDigitalTransformation,
    ];
    return (
      <div>
        <SubScreenHeader title={content.digitalTransformationPageName} />

        <Row
          gutter={[32, 32]}
          style={{
            maxWidth: 1040,
            margin: '0 auto',
            paddingTop: 40,
            paddingBottom: 40,
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <Col
            xs={0}
            md={6}
            style={{
              maxHeight: 'calc(100vh - 160px)',
              overflowY: 'auto',
              position: 'sticky',
              top: 100,
            }}
          >
            <LeftMenu sections={sections} />
          </Col>
          <Col xs={24} md={18}>
            {subPageContent === 'DigitalTransformationContent' && <DigitalTransformationContent />}
          </Col>
        </Row>

        <Footer />
      </div>
    );
  }
}

export default DigitalTransformationScreen;
